import React from 'react';
import _ from 'lodash';
import TemplateInfoComponent from './template-info.component';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const TemplateBasicInfoComponent = ({
  selectedTemplate,
  handleInnerFormChange,
  changeImage,
  mediaFiles,
  handleFormAttachmentItemChange
}: any) => {
  const libraryData = useSelector(selectListItems)
  const tabItems = [
    {
      id: 1,
      title: 'Document Editor',
      component: <TemplateInfoComponent selectedTemplate={selectedTemplate}
        handleInnerFormChange={handleInnerFormChange}
        changeImage={changeImage}
        mediaFiles={mediaFiles}
        handleFormAttachmentItemChange={handleFormAttachmentItemChange}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Web Editor',
      component: <TemplateInfoComponent selectedTemplate={selectedTemplate}
        handleInnerFormChange={handleInnerFormChange}
        changeImage={changeImage}
        mediaFiles={mediaFiles}
        handleFormAttachmentItemChange={handleFormAttachmentItemChange}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'Attachments',
      component: <TemplateInfoComponent selectedTemplate={selectedTemplate}
        handleInnerFormChange={handleInnerFormChange}
        changeImage={changeImage}
        mediaFiles={mediaFiles}
        handleFormAttachmentItemChange={handleFormAttachmentItemChange}
        isAttachment
      />,
      isVisible: true,
    }]
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Template Type"
              labelField="Text"
              list={libraryData?.result?.TemplateType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(event.target.value, 'TemplateTypeId');
              }}
              optionName='Choose Template Type'
              type="select"
              value={selectedTemplate?.TemplateTypeId}
              valueField="Value"
            />

            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(event.target.value, 'Name');
              }}
              type="text"
              value={selectedTemplate?.Name}
            />

            {selectedTemplate?.TemplateTypeId === 40 && (
              <div className='col-span-full'>
                <InputContainer
                  label="Body Content"
                  name="BodyContent"
                  onValueChange={(event: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'BodyContent'
                    )
                  }}
                  type="text"
                  value={selectedTemplate?.BodyContent}
                /></div>
            )}
            {selectedTemplate?.TemplateTypeId !== 40 &&
              selectedTemplate?.TemplateTypeId !== 10 && (
                <div className='col-span-full'>
                  <InputContainer
                    label="Subject"
                    labelField="Subject"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(event.target.value, 'Subject');
                    }}
                    type="text"
                    value={selectedTemplate?.Subject}
                  /></div>
              )}
            {selectedTemplate?.TemplateTypeId === 10 && (
              <InputContainer
                label="Web Template Type"
                labelField="Text"
                list={libraryData?.result?.WebTemplateType}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'WebTemplateTypeId');
                }}
                optionName='Choose Web Template Type'
                type="select"
                value={selectedTemplate?.WebTemplateTypeId}
                valueField="Value"
              />
            )}
            <div className='col-span-full'>
              {selectedTemplate?.TemplateTypeId !== 40 && (
                <AccordionContainer
                  child={

                    <form>

                      <TabContainer tabItems={tabItems} />

                    </form>

                  }
                  expandedPanel="BasicInfo"
                  headerTitle="Basic Information"
                />
              )}</div>
          </div>}
        expandedPanel="Template"
        headerTitle="Template"
      />
    </>
  );
};
export default TemplateBasicInfoComponent;
